import { ISignalP0 } from "./ISignalP0";
import { ISignalP1 } from "./ISignalP1";
import { ISignalP2 } from "./ISignalP2";
import { ISignalOption } from "./ISignalOption";

export class Signal<TListener extends Function>
{

	// ==================================================================================================
	// static create method

	public static create(): ISignalP0;
	public static create<T>(): ISignalP1<T>;
	public static create<T0, T1>(): ISignalP2<T0, T1>;

	public static create()
	{
		return new Signal();
	}

	// ==================================================================================================
	// private members, constructor

	protected _listeners: TListener[];
	protected _options: ISignalOption[];

	constructor()
	{
		this._listeners = [];
		this._options = [];
	}


	// ==================================================================================================
	// add methods

	public add(listener: TListener, option?: ISignalOption)
	{
		var listeners = this._listeners;
		var options = this._options;

		// check if there is a listener added already with the same scope
		for (var i = 0, ln = listeners.length; i < ln; ++i)
		{
			if (listeners[i] === listener &&
				((options[i] && options[i].scope) || this) ===
				((option && option.scope || this)))
			{
				return;
			}
		}

		listeners.push(listener);

		if (option)
		{
			this._options[listeners.length-1] = option;
		}
	}

	public addAndCall(listener: TListener, option?: ISignalOption)
	{
		this.add(listener, option);

		var scope = (option && option.scope) || this;
		listener.call(scope);
	}

	public addOnce(listener: TListener, option?: ISignalOption)
	{
		option = option || {};
		option.addOnce = true;
		this.add(listener, option);
	}

	// ==================================================================================================
	// has

	public has()
	{

	}

	// ==================================================================================================
	// remove methods

	/**
	 * If scope is given -> remove the matching listener with that scope.
	 * If no scope given -> remove all matching listeners (regardless of scope).
	 */
	public remove(listener: TListener, scope?: any)
	{
		var listeners = this._listeners;

		for (var i = listeners.length - 1; i >= 0; --i)
		{
			if (listeners[i] === listener)
			{
				if (scope === undefined)
				{
					listeners.splice(i, 1);
				}
				else if (scope === this._options[i].scope)
				{
					listeners.splice(i, 1);
					// return because there can only be one such match
					return;
				}
			}
		}

		var index = this._listeners.indexOf(listener);

		if(index > -1)
		{
			this._listeners.splice(index, 1);
			if (this._options[index])
			{
				this._options.splice(index, 1);
			}
		}
		return false;
	}

	public removeAll()
	{
		this._listeners.length = 0;
		this._options.length = 0;
	}


	// ==================================================================================================
	// dispatch

	public dispatch(...args)
	{
		var listeners = this._listeners;

		var i = 0;
		while (i < listeners.length)
		{
			var scope = (this._options[i] && this._options[i].scope) || this;
			listeners[i].apply(scope, args);

			if (this._options[i] && this._options[i].addOnce)
			{
				listeners.splice(i, 1);
			}
			else
			{
				// only increment if splice didn't run (everything shifts down in that case)
				++i;
			}
		}

		return listeners.length > 0;
	}


	// ==================================================================================================
	// getters

	public getListeners()
	{
		return this._listeners;
	}
}